import { useLocation } from 'react-router-dom';
import { isRealSite } from '../utils/siteMode';

function Footer() {
  const location = useLocation();
  const isReal = isRealSite(location.pathname);

  return (
    <footer style={{
      backgroundColor: '#282c34',
      padding: '10px',
      color: 'white',
      position: 'fixed',
      bottom: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: '14px'
    }}>
      © 2024 {isReal ? '蓝卡模玩社区' : '蓝卡模玩工作室'} 版权所有 | 苏ICP备2025207312号-1
    </footer>
  );
}

export default Footer;
